import { render, staticRenderFns } from "./FIBCheckbox.vue?vue&type=template&id=991ab6ae&scoped=true&"
import script from "./FIBCheckbox.vue?vue&type=script&lang=js&"
export * from "./FIBCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991ab6ae",
  null
  
)

export default component.exports
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QCheckbox});
